import { generatePath } from 'react-router-dom';
import classNames from 'classnames';
import { t } from 'ttag';

import { publicMemberProfile } from '@urls';
import { Title } from '@ui/Title';
import { Link } from '@ui/Link';
import { ProductCard, Product } from '@components/ProductCard';

import s from './ProductDetailsOwnerProducts.sss';

interface Props {
  className?: string,
  products: Product[],
  username: string,
  hasMore?: boolean,
}

export const ProductDetailsOwnerProducts: React.FC<Props> = ({
  className,
  products,
  username,
  hasMore,
}) => {
  return (
    <div className={classNames(s.root, className)}>
      <Title
        className={s.title}
        type="h3"
        bold={false}
      >
        {t`Ще продаю`}
      </Title>

      <ul className={s.list}>
        {products.map((product) => (
          <li
            key={product.id}
            className={s.item}
          >
            <ProductCard
              {...product}
              type="ProductDetailsProducts"
            />
          </li>
        ))}
      </ul>

      {hasMore && (
        <Link
          className={s.moreLink}
          theme='black'
          to={generatePath(publicMemberProfile, { username })}
        >
          <span className={s.moreLinkText}>
            {t`Всі товари продавця`}
          </span>
        </Link>
      )}
    </div>
  );
};
